import { ViewDataModalState } from '@mode/shared/contract-common';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectViewDataModalState = createFeatureSelector<ViewDataModalState>('viewDataModal');

export const selectPaging = createSelector(selectViewDataModalState, (state) => state.paging);
export const selectIsOpen = createSelector(selectViewDataModalState, (state) => state.isOpen);
export const selectQueryToken = createSelector(selectViewDataModalState, (state) => state.queryToken);
export const selectEncoding = createSelector(selectViewDataModalState, (state) => state.encoding);
export const selectSeriesDetail = createSelector(selectViewDataModalState, (state) => state.seriesDetail);
export const selectTitle = createSelector(selectViewDataModalState, (state) => state.title);
